import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { bankInformationQueries } from '@/services/payment/payment.queries';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export const useManageBankInformation = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation('manageBankInformation', {
    onSuccess: async (response) => {
      toast.success(response.message);
      await queryClient.invalidateQueries({ queryKey: bankInformationQueries.all() });
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });

  return { mutateAsync, isPending };
};
